import React from 'react';
import colors from '~/src/theme/colors';

const LoadingSpinner = () => {
  return (
    <div
      role="presentation"
      className="w-4 h-4 rounded-full animate-spin"
      style={{
        background: `conic-gradient(from 14.04deg at 50% 50%, rgba(255, 255, 255, 0) 0deg, ${colors.bluebird} 360deg)`,
        maskImage:
          'radial-gradient(farthest-side, transparent calc(100% - 2px), black calc(100% - 2px))',
      }}
    />
  );
};

export default LoadingSpinner;
